import { sha3_256 } from 'js-sha3';
import $, { AxiosPromise} from 'axios';
import { GetURI } from '@/plugins/utilities';
import { StorageWars } from '@/plugins/storageWars';
import Cookies from 'js-cookie';
import { JwtHandler } from './jwtHandler';

export class SecurityController {
    public username: string;
    public password: string;
    public now: number;
    private store: StorageWars;
    constructor(user: string | null, password: string | null) {
        this.username = 'csanchez';
        if (user) {
            this.username = user;
            if (this.getUser() === '') {
                this.setUser();
            }
        }
        if (password) {
            this.password = password;
        } else {
            this.password = '';
        }
        this.now = new Date().getUTCMilliseconds();
        this.store = new StorageWars({});
    }
    public setUser(): boolean {
        try {
            this.store = this.checkStore();
            this.store.name = 'lkId';
            this.store.val = this.username;
            return this.store.set();
        } catch (ex) {
            return false;
        }
    }
    public getUser(): string {
        this.store = this.checkStore();
        this.store.name = 'lkId';
        return this.store.get();
    }
    public set(session: string): boolean {
        try {
            this.store = this.checkStore();
            this.store.name = 'sessionId';
            this.store.val = session;
            return this.store.set();
        } catch (ex) {
            return false;
        }
    }
    public getSession(): string {
        this.store = this.checkStore();
        this.store.name = 'sessionId';
        return this.store.get();
    }
    public clear(): void {
        this.username = '';
        this.store = this.checkStore();
        this.store.clear();
    }
    public hash(): string {
        if (this.username !== undefined || this.username !== null) {
            const userHash = sha3_256.create();
            userHash.update(`/${this.username.toLowerCase().trim()}/`);
            return userHash.hex();
        }
        return `\\NO-WAY-IN-HELL\\`;
    }
    public send(): AxiosPromise {
        return $({ url: `${GetURI()}/api/securelogin/${this.hash()}`, method: 'GET' });
    }
    public auth(): AxiosPromise {
        return $({ url: `http://localhost/api/users/login`, method: 'POST', data: { name: this.username, password: this.password } });
        // return $({ url: `${GetURI()}/api/login}`, method: 'POST', data: { name: this.username, password: this.password } });
    }
    public sessionCheck(): boolean {
        const jwtString = Cookies.get('session');
        if (jwtString) {
            const jwt = new JwtHandler(jwtString);
            if (jwt) {
                return jwt.security.valid && jwt.security.signatureValid != undefined;
            } else {
                return false;
            }
        } else {
           return false;
        }
    }
    public verify(resp: object): boolean {
        if ((resp as any).error) {
            return false;
        }
        if ((resp as any).valid) {
            return (resp as any).valid;
        }
        return false;
    }
    private checkStore(): StorageWars {
        if (!this.store) {
            return new StorageWars({});
        } else {
            return this.store;
        }
    }
}
